import { Injectable } from '@angular/core';
import {
	AbstractControl,
	AsyncValidator,
	ValidationErrors,
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CloserSyncInstructionsAPIService } from '../api-repos/mortgages/closer-sync-instructions.api.service';

@Injectable({
	providedIn: 'root',
})
export class LSOEmailExists implements AsyncValidator {
	constructor(
		private instructionApiService: CloserSyncInstructionsAPIService,
	) {}

	validate({
		value: email,
	}: AbstractControl): Observable<ValidationErrors | null> {
		if (!email) return of(null);
		return this.instructionApiService
			.lsoEmailExists(email.toLowerCase().trim())
			.pipe(
				map(({ lsoEmailExists }) =>
					lsoEmailExists ? { emailExistsLso: true } : null,
				),
			);
	}
}
